<template>
  <font-awesome-icon
    icon="sliders-h"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSlidersH } from '@fortawesome/free-solid-svg-icons'

library.add(faSlidersH)

export default {
  name: 'CoozzySlidersHIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
